import InlineText from 'components/elements/texts/InlineText'
import React from 'react'
import styled from 'styled-components'

/**
 * 必須マーク
 */
const RequiredOptional: React.FC<RequiredProps> = (props) => {
  return (
    <StyledRequired {...props}>
      {/* テキストの切り替え */}
      {props.isRequired && '必須'}
      {props.isOption && '任意'}
    </StyledRequired>
  )
}

export type RequiredProps = {
  marginLeft?: string
  marginRight?: string
  isOption?: boolean
  isRequired?: boolean
}

const StyledRequired = styled(InlineText)<{
  marginLeft?: string
  isOption?: boolean
  isRequired?: boolean
}>`
  ${(props): string => {
    switch (true) {
      case props.isOption:
        return `background: blue;
                padding: 2px 5px 1px;
                color: var(--color-text-for-main-background);
                font-size: 10px;
                border-radius: 2px;
                margin-left: 16px;`
      case props.isRequired:
        return `background: var(--color-error);
                padding: 2px 5px 1px;
                color: var(--color-text-for-main-background);
                font-size: 10px;
                border-radius: 2px;
                margin-left: 16px;`
      case !props.marginLeft:
        return `margin-left: ${props.marginLeft}`
      default:
        return ''
    }
  }}
`

export default RequiredOptional
